import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientRepresentativeSaveAddressesMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { AddressesWithFilesParam } from 'api/types/params/onboarding/addressesParam';
import { isFinanceProject } from 'config';

import { parseLegalClientRepresentative } from './helpers';

export const useLegalClientRepresentativeSaveAddresses = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientRepresentativeSaveAddressesMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientRepresentativeSaveAddresses
      ? parseLegalClientRepresentative(
          data.legalClientRepresentativeSaveAddresses
        )
      : undefined,
    loading,
    error,
    saveAddresses: useCallback(
      async (id: string, params: AddressesWithFilesParam) => {
        const res = await handle({
          variables: {
            id,
            input: {
              placeOfBirth: params.placeOfBirth,
              registrationAddress: isFinanceProject()
                ? params.registrationAddress
                : undefined,
              residentialAddress: params.residentialAddress,
            },
          },
        });
        return res?.data?.legalClientRepresentativeSaveAddresses
          ? parseLegalClientRepresentative(
              res.data.legalClientRepresentativeSaveAddresses
            )
          : undefined;
      },
      [handle]
    ),
  };
};
